module.exports = __webpack_public_path__ + "img/add-circle.3660f226.svg";